import { render, staticRenderFns } from "./OrkRecaptcha.html?vue&type=template&id=1a5aaf5e&scoped=true&"
import script from "./OrkRecaptcha.vue?vue&type=script&lang=js&"
export * from "./OrkRecaptcha.vue?vue&type=script&lang=js&"
import style0 from "./OrkRecaptcha.scss?vue&type=style&index=0&id=1a5aaf5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5aaf5e",
  null
  
)

export default component.exports